import { completeFromList } from '@codemirror/autocomplete';
import { htmlLanguage } from '@codemirror/lang-html';
import { foldInside, foldNodeProp, indentNodeProp, LanguageSupport, LRLanguage } from '@codemirror/language';
import { parseMixed } from '@lezer/common';

import { LIQUID_TAGS } from '@client/enums/liquid-tags';

import { parser } from './liquid.grammar.js';
import { liquidStyleTags } from './liquid-style';

export const languageDefinition = LRLanguage.define({
  parser: parser.configure({
    name: 'liquid',
    props: [
      liquidStyleTags,
      foldNodeProp.add({ Conditional: foldInside }),
      indentNodeProp.add({
        Conditional: (cx) => {
          let closed = /^\s*\{% end/.test(cx.textAfter);
          return cx.lineIndent(cx.node.from) + (closed ? 0 : cx.unit);
        }
      })
    ],
    wrap: parseMixed((node) => {
      return node.type.isTop
        ? {
            parser: htmlLanguage.parser,
            overlay: (node) => node.type.name === 'Text'
          }
        : null;
    })
  })
});

const languageDefinitionConfig = languageDefinition.data.of({
  autocomplete: completeFromList(LIQUID_TAGS.map((tag) => ({ label: tag, type: 'keyword' })))
});

export const liquidLanguage = new LanguageSupport(languageDefinition, [languageDefinitionConfig]);
